import { generateUrl } from '.'

function traverse(current, res, maxdepth = 0) {
    //process current node here
    res = {
        id: current.id,
        label: current.title,
        link: current.forward_link ?? generateUrl(current, 'service')
    }
    if (current.thumbnail?.hash)
        res.thumbnail = `/api/filedb/${current.thumbnail.hash}.${current.thumbnail.ext}`
    res.children = [] //.map(c => traverse(tree, c, ))
    if (current.children?.length) maxdepth += 1
    //visit children of current
    for (let ck of current.children.sort((a, b) => a.position.localeCompare(b.position)))
        res.children.push(traverse(ck, void 0, maxdepth))

    res.maxDepth = maxdepth
    return res
}

export function createServiceMenu(menuServices) {
    let a = menuServices
        .map(a => ({
            ...a,
            position: [a.parent?.position?.padStart(3, '0') ?? '', a.position?.padStart(3, '0') ?? '999'].join('.')
        }))
    return a
        .sort((a, b) => a.position.localeCompare(b.position))
        .map((s) => traverse(s))
}
